module.exports = __webpack_public_path__ + "assets/img/SQC_logo_signature_white.0eaef328.svg";